import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_BY_LENDER = gql`
  query LenderRetailActivityByLender($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      byLender(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          country
          approved
          approvedAmount
          declined
          pending
          approvalRate
          funded
          fundedAmount
          requestedAmount
          # syndications removed from schema
        }
      }
    }
  }
`;
